import React from "react";
import "../post.css";
import DayOne from "../images/day_one.jpg";

export default class Post extends React.Component {
  render() {
    return (
      <div className="card">
        <h2 className="header">Day One</h2>
        <img className="image" alt="itinerary" src={DayOne} />
        <div className="infobar">
          <div className="info">20 Nov 2018</div>
        </div>
        <h3>Tokyo</h3>
        <p>
          Arrive at Tokyo International Airport at night. Take the train to
          Nishi-Nippori Station. Check-in to the Airbnb. Kitchen Origin has
          grab-and-go food.
        </p>
      </div>
    );
  }
}
